
        import 'CompanyDetails.c2e1a41.css-module'
        export default {"content":"content_CompanyDetails_c2e1a41","invalid":"invalid_CompanyDetails_c2e1a41","companyTypeahead":"companyTypeahead_CompanyDetails_c2e1a41"}
    